import { apiRequest } from '@/services/api'
import { customLogger } from "@/utils";

const state = {
  storeId: undefined,
  boxEnabled: !!window.localStorage.cleed_enabled,
  showBox: !!window.localStorage.cleed_showBox,
  abTesting: undefined,
  displayCondition: undefined,
  chat_enabled: undefined,
  details: undefined,
  chat_config: undefined,
  steps: undefined,
  i18n: undefined,
  style: undefined,
  selectors: undefined,
  product_card: undefined,
  chatgpt: undefined,
  openai_question_counter: undefined,
  appIsVisible: true,
  emailActivate: undefined
}

const actions = {
  FETCH_STORE_ID: async ({ commit }, guid) => {
    const storeId = (await apiRequest().post('stores/id', { 'guid': guid })).data.response.store_id
    commit('SET_CONFIG', { 'storeId': storeId })
    return storeId
  },

  FETCH_CONFIG: async ({ commit, state }) => {
    const config = (await apiRequest().get(`stores/id/${state.storeId}`)).data.response
    const config_modulable = (await apiRequest().get(`store_config/id/${state.storeId}`)).data.response

    commit('SET_CONFIG', { ...config, ...config_modulable })
    return config
  }
}

const mutations = {
  SET_CONFIG: (state, config) => {
    Object.keys(state).forEach(k => {
      if (config[k] !== undefined) state[k] = config[k]
    })
    if ('enabled' in config) {
      state.boxEnabled = state.boxEnabled || document.location.hostname === 'localhost' || config.enabled
    }
  },
  UPDATE_CHAT_CONFIG:(state, newConfig) =>{
    customLogger('Change Chat Config : ');
    if (state.chat_config){
      state.chat_config = newConfig
      customLogger('Set newConfig', newConfig);
    }
  },
  SHOW_BOX: (state) => {
    state.showBox = true
  }
}


const getters = {

  // Returns the store's id
  store_id (state) {
    return state.storeId;
  }

}


export default {
  state,
  actions,
  mutations,
  getters
}
